module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/288_title_freespins@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/288_title_freespins@2x.png
// module id = 696
// module chunks = 0